import React, { useState } from "react";
import renderComponent from "../renderComponent";

function CalenderWrapperControl1({ subcomponents = [] }) {
  console.log("Calender subcomponents", subcomponents);
  const [selectedCalenderControl, setSelectedCalenderControl] = useState(null);

  const [CalenderFilter] = subcomponents;
  const customSubcomponents = [CalenderFilter, selectedCalenderControl];

  let subcomponentstoUse = [];

  if (selectedCalenderControl) {
    subcomponentstoUse = customSubcomponents;
  } else {
    subcomponentstoUse = subcomponents;
  }

  console.log("the subcomponentstoUse", subcomponentstoUse);
  console.log("the selectedcalenderControl", selectedCalenderControl);
  return (
    <div className="w-full flex flex-col gap-4 sm:gap-6 pt-8">
      {subcomponentstoUse?.map((config, idx) => (
        <div key={idx} className="w-full">
          {renderComponent(config, {
            selectedCalenderControl,
            setSelectedCalenderControl,
          })}
        </div>
      ))}
    </div>
  );
}

export default CalenderWrapperControl1;
